import { Injectable } from '@angular/core';
import {User} from '../../interfaces/core/user';
import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {AuthService} from './auth.service';
import {map, tap} from 'rxjs/operators';
import {UserFactory} from '../../factories/core/user-factory';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private static _user: User = null;
  private static _storageKey = 'user';

  /**
   *
   * @param httpService
   * @param storageService
   */
  constructor(private httpService: HttpService,
              private storageService: StorageService) { }

  /**
   *
   */
  public static get storageKey(): string {
    return this._storageKey;
  }

  /**
   *
   */
  public async init(): Promise<void> {
    UserService._user = await this.storageService.getItem(UserService._storageKey);
  }

  /**
   *
   */
  public static getUser(): User {
    return UserService._user;
  }

  /**
   *
   */
  public static async removeUser(): Promise<void> {
    await StorageService.removeItem('user');
    this._user = null;
  }

  /**
   *
   */
  public loadUser(): Observable<User> {
    return this.httpService.get<any>({
      url: ['user', AuthService.getAuthToken().userId.toString()]
    }).pipe(map((_user) => {
      return UserFactory.fromObject(_user);
    }), tap((_user) => {
      this.setUser(_user).finally();
    }));
  };

  /**
   *
   * @private
   */
  private async setUser(user: User): Promise<void> {
    UserService._user = user;
    await this.storageService.setItem('user', user);
  }

}
